import Vue from "vue";

export default {
    setCanMakeInvoice(state, payload) {
        Vue.set(state,"can_make_invoice", payload)
    }
}
